import { getApi } from '../../../utils/api'

export function getVariableList(params) {
  return getApi({
    endpoint: `/api/text-module/message-snippet/variables/`,
    params,
  })
}
